export default "__VITE_ASSET__BmKhvc1D__"